import { Button, Col, Empty, Form, Input, Row, Space, Spin } from "antd"
import React, { useContext, useEffect, useMemo, useState } from "react"
import { useProcurarViagemPelaSenha } from "../../../../Services/Domain/Viagem/ViagemService"
import { useForm } from "antd/lib/form/Form"
import { AxiosError, HttpStatusCode } from "axios"
import { DescricaoDaViagem } from "../../../../Views/Viagem/Cadastros/Viagem/Componentes/DescricaoDaViagem"
import { TypeViagem } from "../../../../Models/Domain/Viagem/Viagem"
import { notificarErroNaRequisicao } from "../../../../Utils/Notificacoes"
import { SearchOutlined } from "@ant-design/icons"
import { SessaoARContext } from "../../../Contexts/SessaoContext"
import { ParametrosDaSessaoARContext, ParametrosDaSessaoDoResponsavel } from "../../../Views/Sistema/ParametrosDaSessao"
import { EnumTipoUsuario } from "../../../../Models/Domain/AreaRestrita/Sessao"

export const EncontrarViagemPelaSenhaParaTipoResponsavel: React.FC<{
    viagemAPI: [TypeViagem | undefined, React.Dispatch<React.SetStateAction<TypeViagem | undefined>>]
}> = (props) => {

    const SessaoAR = useContext(SessaoARContext);
    const parametrosDaSessaoAR = useContext(ParametrosDaSessaoARContext) as ParametrosDaSessaoDoResponsavel;
    const {alunoSelecionado} = parametrosDaSessaoAR;

    const [viagem, setViagem] = props.viagemAPI;

    interface IFormularioDeSenhaDaViagem {
        senha: string
    }

    const [ form ] = useForm<IFormularioDeSenhaDaViagem>()

    const viagemQuery = useProcurarViagemPelaSenha({
        axiosConfig: {doNotNotify: true},
        onError(error) {
            const erroComoAxiosError = error as AxiosError;

            if (erroComoAxiosError != undefined && (erroComoAxiosError.response?.data as any)?.mensagem  ) {
                form.setFields([{ name: "senha", errors: [(erroComoAxiosError.response?.data as any)?.mensagem] }])
                setViagem(undefined)
            } 
            else {
                notificarErroNaRequisicao(erroComoAxiosError)
            }
            
        },
    });

    const {data} = viagemQuery;

    useEffect(() => {
        if(viagemQuery.isIdle == true) return;

        if (data?.data?.alunosInformados == true) {
            /* O backend identifica o responsável que fez a requisição e, caso a viagem tenha alunos informados, inclui as inscrições disponíveis para aquele responsável. Esse segmento de código lida com as variabilidades que dai se originam . */
            const mensagem: string = (() => {
                if (alunoSelecionado?.codigo == undefined) {
                    return "A viagem possui inscrições controladas. Selecione um aluno que tenha permissões para acessá-la e tente novamente.";
                };

                const alunoSelecionadoEstaInclusoNaViagem = (
                    data.data.inscricoesDisponiveis.some((inscricao) => inscricao.aluno?.codigo == alunoSelecionado.codigo)
                );

                /* E se o aluno selecionado estiver inscrito mas o status da inscrição for 'cancelado'? */
                return alunoSelecionadoEstaInclusoNaViagem ?
                    "O aluno já está inscrito na viagem" :
                    "A viagem não está disponível para o aluno selecionado, mas está para outro de seus tutelados. Certifique-se que o aluno da sessão está corretamente selecionado.";
            })()

            form.setFields([{ name: "senha", errors: [mensagem] }])
            setViagem(undefined);
            return;
        } 

        setViagem(data?.data?.viagem)
    }, [data])

    const sessaoValida = SessaoAR?.sessao?.tipoDeUsuario === EnumTipoUsuario.Responsavel;
    if (sessaoValida === false) return <Empty description="A sessão atual da Area Restrita não é uma sessão do tipo responsável" />;

    return <React.Fragment>
        <Form<IFormularioDeSenhaDaViagem> form={form} layout="vertical" size="large" autoComplete="off"
            onFinish={(values) => {
                viagemQuery.mutate({ senha: values.senha })
            }}
        >
            <Form.Item<IFormularioDeSenhaDaViagem> name={"senha"} label="Insira a senha da viagem"
                rules={[{required: true, message: "O campo é obrigtório"}]}
            >
                <Space.Compact style={{ width: '100%' }} size="large">
                    <Input placeholder="ABCDXYZ" 
                    />
                    <Button htmlType="submit" type="primary"
                        icon={<SearchOutlined />}
                        loading={viagemQuery.isPending}
                    />
                </Space.Compact>
            </Form.Item>
        </Form>

        {(() => {
            if(viagem == undefined) return <></>

            return (
                <React.Fragment>
                    <Spin spinning={viagemQuery.isPending}>
                        {viagem != undefined && <DescricaoDaViagem viagem={viagem} ocultarDescricao />}
                    </Spin>
                </React.Fragment>
            )
        })()}

    </React.Fragment>
}
